export default {
    title: '',
    pages: [],
    footer: null,
    loading: false,
    hide: false,
    current: null,
    currentSlide: 0,
    posts: [],
    relatedPosts: {},
    postsByCategory: [],
    postsByAuthor: [],
    totalPages: [],
    comments: [],
    comment: null,
    threadComment: null,
    currentPage: 1,
    currentCategory: '',
    post: {},
    threadComments: [],
    firstTwoReplies: [],
    hasComments: '',
    hero: {
      slides: [],
      showSlideShow: false,
      originalSlides: [],
      hideTitle: false,
      navigateTo: null,
      slide: null,
      frontSlide: {},
    },
    themeColor: 'white',
}